module.exports = __webpack_public_path__ + "img/section-header.2dc7164.svg";